module.exports = {"id":"202399","name":"Diego Arias","rating":"72","photo":"./data/images/photos/2/202399.png","club":{"name":"Atl. Nacional","logo":"./data/images/clubs/Atl.Nacional.png"},"positions":["MDC","MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DiegoArias0.json
// module id = 1068
// module chunks = 0